import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { Observable, Subscription } from 'rxjs';
import { HospitalService } from '../_services';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-hospital',
  templateUrl: './hospital.component.html',
  styleUrls: ['./hospital.component.scss']
})
export class HopitalComponent implements OnInit , OnDestroy{
  language: any;
  Hospitals;
  page;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; 
  constructor(private translationService: TranslationService,private HospitalService: HospitalService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.page = this.route.snapshot.params['page'];
    this.language = this.translationService.getSelectedLanguage();
    const sb = this.HospitalService.GetAllHospitalsByTypeId(this.page).subscribe(res => {
      if (res != null) {
        this.Hospitals = res;
      }
    });
    this.subscriptions.push(sb);
    this.isLoading$ = this.HospitalService.isLoading$;
  }
  openWebsite(url: string): void {
  if (url) {
    window.open(url, '_blank');
  }
}
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
